import { render } from "./CatEmpleadoForm.vue?vue&type=template&id=38ae5f9a&scoped=true"
import script from "./CatEmpleadoForm.vue?vue&type=script&lang=js"
export * from "./CatEmpleadoForm.vue?vue&type=script&lang=js"

import "./CatEmpleadoForm.vue?vue&type=style&index=0&id=38ae5f9a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ae5f9a"]])

export default __exports__